

// components/tracking/LoadingState.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const LoadingSkeleton = () => (
  <div className="animate-pulse space-y-6 max-w-6xl mx-auto px-4">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-white rounded-lg shadow p-6 space-y-3">
        <div className="h-6 bg-gray-300 rounded w-1/3"></div>
        <div className="space-y-2">
          {[...Array(7)].map((_, i) => (
            <div key={i} className="h-4 bg-gray-200 rounded w-full"></div>
          ))}
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="h-6 bg-gray-300 rounded w-1/3 mx-auto mb-4"></div>
        <div className="h-8 bg-gray-300 rounded w-2/3 mx-auto mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div>
      </div>
    </div>
    <div className="bg-white rounded-lg shadow p-6">
      <div className="h-6 bg-gray-300 rounded w-1/4 mb-4"></div>
      <div className="space-y-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex gap-4">
            <div className="w-32 h-4 bg-gray-200 rounded"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="h-3 bg-gray-100 rounded w-1/2"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const LoadingState = ({ lottieSrc }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95 }}
    transition={{ duration: 0.4 }}
    className="flex-1 pt-10 pb-20"
  >
    <div className="text-center mb-8">
      <DotLottieReact
        src={lottieSrc}
        autoplay
        loop
        style={{ width: 120, height: 120, margin: '0 auto' }}
      />
      <p className="text-xl font-medium text-blue-600 mt-4">
        Fetching Tracking Information...
      </p>
      <p className="text-gray-500 mt-2">Please wait while we retrieve your shipment details</p>
    </div>
    <LoadingSkeleton />
  </motion.div>
);

export default LoadingState;

// ============================================================================